import {
  SUBMIT_DIALOG_ACCEPT,
  SUBMIT_DIALOG_SHOW,
  SUBMIT_DIALOG_REJECT,
  SUBMIT_DIALOG_CLOSE
} from "../lib/types";

const initialState = {
  project: null,
  hidden: true
};

export default (state = initialState, action) => {
  /* discriminate the action type */
  switch (action.type) {
    case SUBMIT_DIALOG_ACCEPT:
      return {
        ...state,
        hidden: true
      };
    case SUBMIT_DIALOG_REJECT:
      return {
        ...state,
        hidden: true
      };
    case SUBMIT_DIALOG_SHOW:
      return {
        ...state,
        hidden: false
      };
    case SUBMIT_DIALOG_CLOSE:
      return {
        ...state,
        hidden: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/submit-dialog-reducer.js